import createTeacher from './create-teacher/index';

export default {
  modules: {
    'create-teacher': createTeacher,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/learning-center/index.js